<app-page-header icon="upload_file" title="Padrones Médicos" subtitle="Importación y gestión de centros médicos desde padrones"></app-page-header>

<div class="features-area pb-24">
    <div class="container">
        <!-- 🧩 Grilla compacta idéntica al menú principal -->
        <div class="grid">
            <div
                class="card"
                *ngFor="let it of items; trackBy: trackByTitle"
            >
                <div class="icon" [style.color]="it.color">
                    <i [class]="it.icon" aria-hidden="true"></i>
                </div>
                <div class="title">{{ it.title }}</div>
                <div class="desc">{{ it.desc }}</div>
                <a class="btn-ghost" [routerLink]="it.route">
                    Abrir <i class="fas fa-arrow-right" aria-hidden="true"></i>
                </a>
            </div>
        </div>

        <!-- Botón Volver -->
        <div class="mt-4">
            <a class="btn-ghost" [routerLink]="['/configurar-administracion']">
                <i class="fas fa-arrow-left mr-2"></i> Volver a Administración
            </a>
        </div>
    </div>
</div>
